import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "InfoBoxContainer" }
const _hoisted_2 = { class: "Info_Text" }
const _hoisted_3 = { class: "TitleText" }
const _hoisted_4 = { class: "ContentText" }
const _hoisted_5 = { class: "Info_Image" }
const _hoisted_6 = { class: "InfoImage_Content" }
const _hoisted_7 = ["src"]

import { ref, watch } from 'vue';
import useGlobalStateStore from "@/Store/GlobalStateStore";

enum Enum_Theme { Dark, Light }

export default /*@__PURE__*/_defineComponent({
  __name: 'InfoBox_Left',
  props: { Title: String, Summary: String, ImagePath: String },
  emits: ['openModal'],
  setup(__props, { emit: __emit }) {

_useCssVars(_ctx => ({
  "v21aeaa3b": (ThemeTitleText.value),
  "v3bc45bc1": (ThemeTitleTextHover.value),
  "v39c5765c": (ThemeContentText.value)
}))

const props = __props;
const emit = __emit;

const GlobalStyleStore = useGlobalStateStore();
const handleClick = () => emit('openModal');

const ThemeTitleText = ref("#FFF");
const ThemeTitleTextHover = ref("#57E1D9");
const ThemeContentText = ref("#cecece");

watch(GlobalStyleStore, () => {
  if (GlobalStyleStore.CurrentTheme === Enum_Theme.Dark){
    ThemeTitleText.value='#FFF'; ThemeTitleTextHover.value='#57E1D9'; ThemeContentText.value='#cecece';
  } else {
    ThemeTitleText.value='#545454'; ThemeTitleTextHover.value='#f77373'; ThemeContentText.value='#484848';
  }
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "InfoBoxBG",
    onClick: handleClick
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(props.Title), 1),
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "PartingLine" }, null, -1)),
        _createElementVNode("div", _hoisted_4, _toDisplayString(props.Summary || '点击查看详情...'), 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("img", {
            src: props.ImagePath,
            alt: "Cover"
          }, null, 8, _hoisted_7)
        ])
      ])
    ])
  ]))
}
}

})